export const PRODUCT_IMG =
  'https://cdn.magicpatterns.com/uploads/dtLqEhJ8KZd8b5kzo6vEqZ/ChatGPT-Image-5-jul-2026_-10_21_30-p.m..webp'

export const CHECKOUT_URL =
  'https://gymnastics-coach-pro.impultienda.ar/checkout'

export const PRODUCT_NAME = 'GYMNASTICS COACH PRO™'
